export const STUDENT_MAIN_ONBOARDING = 'student_main_onboarding';
export const STUDENT_APPLICATION_MANAGER_FERPA_WAIVER =
  'student_application_manager_ferpa_waiver';
export const STUDENT_FYP_ONBOARDING = 'fyp_completed';
export const LOR_ONBOARDING = 'lor_onboarding';
export const LOR_FERPA_WAIVER = 'lor_ferpa_waiver';
export const MOBILE_VR_TOUR = 'mobile_vr_tour';
export const PICKER_PREVIEW = 'picker_preview';
export const MOBILE_ONBOARDING = 'mobile_onboarding';
export const GUARDIAN_ONBOARDING = 'guardian_onboarding';
export const MEMBER_VIDEO_CREATION_ONBOARDING =
  'member_video_creation_onboarding';
export const MEMBER_ALUM_SKIP_AFFILIATION = 'member_alum_skip_affiliation';
export const COLLEGE_APPLICATIONS_ONBOARDING =
  'college_applications_onboarding';
export const HOW_TO_USE_FILTER = 'how_to_use_filter';
export const UPDATE_ALUMNI_CONTACT_INFO = 'update_alumni_contact_info';
export const SENIOR_SURVEY_INTRO_SCREEN = 'senior_survey_intro_screen';
